import Component from 'e-submission/components/Card/EditCard'

export default (hoc) => hoc(Component)
